if (!window.AW_KLAVIYO_INITIALIZED ) {
  class AWKlaviyo {
    #isSubmitting = false;
    #apiUrl = 'https://a.klaviyo.com/client';
    #headers = {
      revision: '2026-04-15',
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    };

    constructor() {
      window.AW_KLAVIYO_INITIALIZED = true;

      this.#setListeners();
    }

    #setListeners() {
      document.addEventListener('aw-klaviyo:subscribe', this.#subscribe.bind(this));
      document.addEventListener('aw-klaviyo:send-event', this.#sendEvent.bind(this));
    }

    /**
     *
     * @param {CustomEvent} event
     */
    async #subscribe(event) {
      const { email, callback } = event.detail;

      if (!Theme.klaviyo.siteId) {
        console.warn('[Klaviyo] Site ID is empty.');
        return;
      }

      if (!Theme.klaviyo.listId) {
        console.warn('[Klaviyo] List ID is empty.');
        return;
      }

      if (this.#isSubmitting) return;

      this.#isSubmitting = true;

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: Theme.klaviyo.listId
              }
            }
          }
        }
      };

      try {
        const res = await this.#request('subscriptions', body);

        callback?.({ status: res.status === 202 ? 'success' : 'fail' });
      } catch (error) {
        console.error(error);

        callback?.({ status: 'fail' });
      } finally {
        this.#isSubmitting = false;
      }
    }

    /**
     *
     * @param {CustomEvent} event
     */
    async #sendEvent(event) {
      const { email, content, productName, productImage, callback } = event.detail;

      if (!Theme.klaviyo.siteId) {
        console.warn('[Klaviyo] Site ID is empty.');
        return;
      }

      if (this.#isSubmitting) return;

      this.#isSubmitting = true;

      const body = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              event_content: content,
              product_name: productName,
              product_image: productImage,
            },
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: 'AW Exclusive Offer'
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email
                }
              }
            }
          }
        }
      };

      try {
        const res = await this.#request('events', body);

        callback?.({ status: res.status === 202 ? 'success' : 'fail' });
      } catch (error) {
        console.error(error);

        callback?.({ status: 'fail' });
      } finally {
        this.#isSubmitting = false;
      }
    }

    /**
     *
     * @param {String} endpoint
     * @param {Object} body
     */
    async #request(endpoint, body) {
      const res = await fetch(`${ this.#apiUrl }/${ endpoint }?company_id=${ Theme.klaviyo.siteId }`, {
        method: 'POST',
        headers: this.#headers,
        body: JSON.stringify(body)
      });

      return res;
    }
  }

  new AWKlaviyo();
}
